<template>

  <v-container fluid>
         
    <!-- 행사정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_event" @keydown.esc="dialog_event = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_eventinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_event = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field v-model="eventItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="eventItem.NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_START" :label="$t('common_eventinfo_label2')" disabled></v-text-field>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_END" :label="$t('common_eventinfo_label3')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.TYPENAME" :label="$t('common_eventinfo_label4')" disabled></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_event = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>   
    </v-row>    

    <v-row align="center" dense>
      <v-col cols="12" md="3">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
      
  </v-row>

  <v-row dense no-gutters>
    <v-col cols="12" class="d-flex">
      <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
      <label class="total_label">{{$t('common_cnt')}}</label><label class="total_label">{{totalsum}}</label>
      <label class="total_label">{{'/'+$t('eventinvit_col15')+":"}}</label><label class="total_label">{{totalsum1}}</label>
      <label class="total_label">{{'/'+$t('eventinvit_col16')+":"}}</label><label class="total_label">{{totalsum2}}</label>
      <v-spacer/>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#4e6ef7" class="mr-2" elevation="1" small @click="getallinfo()"><v-icon>mdi-sync</v-icon></v-btn>
        </template>
        <span>{{$t("eventinvit_col20")}}</span>
      </v-tooltip>
    </v-col>
  </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        > 
        
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t("eventinvit_col2")}}</a>
        </template>
        <template v-slot:header.COUNT>
          <label class="cheader_normal" >{{$t("eventinvit_col14")}}</label>
        </template>        
        <template v-slot:header.REQDATE>
          <a :class="sort_name=='REQDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('SENDDATE')">{{$t("eventinvit_col12")}}</a>
        </template>
        <template v-slot:header.printlist>
          <label class="cheader_normal" >{{$t("eventinvit_col10")}}</label>
        </template>        

        <template v-slot:header.SUM1>
          <label class="cheader_normal" >{{$t("eventinvit_col15")}}</label>
        </template>
        <template v-slot:header.SUM2>
          <label class="cheader_normal" >{{$t("eventinvit_col16")}}</label>
        </template>

        <template v-slot:item.SUM1="{ item }">  
          {{ item.SUM1 == -1 ? '-' :  item.SUM1 }}
        </template>
        <template v-slot:item.SUM2="{ item }">  
          {{ item.SUM2 == -1 ? '-' :  item.SUM2 }}
        </template>
        <template v-slot:item.EVENT_NAME="{ item }">  
          <a @click="loadevent(item.EVENT_IDX)" >{{item.EVENT_NAME}}</a>
        </template>
        <template v-slot:item.printlist="{ item }">  
          <v-icon small @click="getReqinfo(item.REQUESTID)">mdi-link</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>


  </v-container>
</template>

<script>
export default {

    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      totalsum : 0,
      totalsum1 : 0,       //전체성공
      totalsum2 : 0,       //전체실패

      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '발송하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          PHONE:null,
          USER_IDX:null,
          COM_IDX:null,
          COM_NAME:'',
          EVENT_IDX:null,
          EVENT_NAME:'',
      },
      editedItem: {
      },

      infoItem:[],    //행사별 기본접수양식 커스텀 정보

      //테이블 정의
      headers: [
        {text: '행사명', value: 'EVENT_NAME', sortable: false, align:'center' },
        {text: '발송건수',  value: 'COUNT', sortable: false, align:'center' },
        {text: '성공',  value: 'SUM1', sortable: false, align:'center' },
        {text: '실패',  value: 'SUM2', sortable: false, align:'center' },
        {text: '발송일시',    value: 'REQDATE', sortable: false, align:'center' },
        {text: '발송정보',  value: 'printlist', sortable: false, align:'center'},
      ],
      itemList: [],


      sort_name: 'SENDDATE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 500,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
        , {NAME:'500', VALUE:500}
      ],    

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

      
      dialog_event:false,
      dialog_option:false,
      
      visitorItem: {},
      eventItem: {},
      odItem: {},
      
      SELECT_EMAIL_IDX:null,
      SELECT_EMAIL_NAME:'',
      insertType:1

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");
      
      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      getallinfo(){
        this.$confirm(this.$t("eventinvit_col21"))
        .then(() => {
          this.uploadlist();
        });
      },

      uploadlist(){

        if(this.itemList.length == 0){
          this.$alert(this.$t('eventinvit_col19'));
          return;
        }

        //reqid만 배열로 리턴
        const reqlist = this.itemList.map(item => item.REQUESTID);

        //서버로 전송해서 처리
        this.$http.post(this.$host+'/api/SyncEmailList',{
            JSONVALUE: JSON.stringify(reqlist)
          , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , COM_IDX: this.SEARCH_COM_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.$alert(this.$t('common_process_msg')).then(()=>{
              this.page = 0;
              this.loadpage(1);
            });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t("common_process_fail"));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.$alert(this.$t("common_process_fail"));
        });

      },      

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
        
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
        if(this.grade < 99){
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
        }

        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EmailAlimList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.totalcnt = result.data.totalcnt;
                this.totalsum = result.data.totalsum;
                this.totalsum1 = result.data.SUM1TOTAL;
                this.totalsum2 = result.data.SUM2TOTAL;
                
                this.makepaging();
                const list = result.data.resultData;
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },


      //검색
      search_run(){

        this.loadpage(1);

      },
      
      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage(1);
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        //console.log(JSON.stringify(val1));
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
        }
        this.loadpage(1);
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.search_run();
      },


      loadevent(eidx){

          this.$http.post(this.$host+'/api/EventDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.eventItem = list[0];
                this.dialog_event = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },



      //발송내역 확인
      getReqinfo(reqid){
        if(reqid != null && reqid != undefined){
          this.$router.push({path:"/EmailDetailList", query:{event:this.SEARCH_EVENT_IDX, com:this.SEARCH_COM_IDX, rid:reqid}});
        }else{
          this.$alert(this.$t('eventinvit_msg30'));
        }
      },      




    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>